import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./5th.css";


import { FaBookOpen } from "react-icons/fa";
import { MdTranslate } from "react-icons/md";
import { TbMath } from "react-icons/tb";
import { GiTreeBranch } from "react-icons/gi";
import { FaLanguage } from "react-icons/fa";

const content = {
  en: {
    heading: "📘 5th Standard Subjects",
    subjects: [
      {
        name: "Marathi",
        icon: <MdTranslate />,
        backendSubject: "Marathi",
      },
      {
        name: "English",
        icon: <FaLanguage />,
        backendSubject: "English",
      },
      {
        name: "Mathematics",
        icon: <TbMath />,
        backendSubject: "Maths",
      },
      {
        name: "Hindi",
        icon: <FaBookOpen />,
         backendSubject: "Hindi",
      },
      {
        name: "Environmental Studies",
        icon: <GiTreeBranch />,
         backendSubject: "Evs",
      },
    ],
  },

  mr: {
    heading: "📘 इयत्ता ५ वी विषय",
    subjects: [
      {
        name: "मराठी",
        icon: <MdTranslate />,
         backendSubject: "Marathi",
      },
      {
        name: "इंग्रजी",
        icon: <FaLanguage />,
         backendSubject: "English",
      },
      {
        name: "गणित",
        icon: <TbMath />,
         backendSubject: "Maths",
      },
      {
        name: "हिंदी",
        icon: <FaBookOpen />,
         backendSubject: "Hindi",
      },
      {
        name: "परिसर अभ्यास",
        icon: <GiTreeBranch />,
         backendSubject: "Evs",
      },
    ],
  },
};

const Fifth = ({ language = "mr" }) => {
  useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  const selected = content[language];
  const navigate = useNavigate();
  
    const handleClick = (backendSubject) => {
  
      navigate("/quiz-details", {
  
        state: {
  
          standard: 5,
  
          subject: backendSubject
  
        }
  
      });
    }

  return (
    <section className="standard-section-5">

      <h2 className="standard-title-5">{selected.heading}</h2>

      <div className="subjects-container-5">

        {selected.subjects.map((subject, index) => (
          <div
            key={index}
            className={`subject-card-5 subject5-${index}`}
            onClick={() => handleClick(subject.backendSubject)}
          >
            <div className="subject-content-5">
              <div className="subject-icon-5">{subject.icon}</div>
              <h3>{subject.name}</h3>
            </div>
          </div>
        ))}

      </div>

    </section>
  );
};

export default Fifth;